/**
 * electric claimable create
 *
 * Creates a new claimable source and prints the claim ID.
 * This is a public endpoint — no authentication required.
 */

import { Command } from 'commander'
import { createPublicClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printKeyValue } from '../../output.js'

export const claimCreateCommand = new Command(`create`)
  .description(`Provision a Postgres database with Sync`)
  .action(async () => {
    const json = claimCreateCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createPublicClient()
      const result = await client.claimable.create({})

      if (isQuiet()) {
        printQuiet(result.claimId)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printKeyValue([[`Claim ID:`, result.claimId]])
        process.stderr.write(
          `\nCheck provisioning status with: electric claimable status ${result.claimId}\n`
        )
      }
    } catch (error) {
      await handleError(error, json)
    }
  })
